import Paper from "@mui/material/Paper";
import PaymentInstallment from "components/PaymentInstallment/PaymentInstallment";
import { numberFormat } from "helper/numberFormat";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { formSlice } from "services/api/forms";
import {
  DataFoundWrapper,
  PayDetails,
  PaymentAmount,
  SummaryItem,
  SummaryItemCharge,
  SummaryItemInfo,
  SummaryItemName,
  SummaryTitle,
  TotalDueAmount,
  TotalPayment,
  Wrapper,
} from "./Theme";
import { Fonts, FontColors } from "theme/fontConfig";

export const SummaryCard = ({
  handleTotalForPay,
  newProducts,
  setProducts,
  totalDiscount,
  isInstallmentEnabled,
  setActivePaymentAfter,
  calculateAmount,
  activePayment,
  setConvenienceFeeByPayment,
  convenienceFeeByPayment,
  currentPaymentMethod,
}) => {
  const { formOnlineData } = useSelector((state) => state?.Forms);
  const totalPay = handleTotalForPay();
  const dispatch = useDispatch();

  const calculateInstallmentAmount = (item) => {
    if (!item?.installmentStatus) return "";
    if (item?.installment?.value) {
      const itemAmount = item?.amount;
      return numberFormat({
        number: +itemAmount / item?.installment?.value,
        decimal: 2,
        style: "currency",
      });
    }
    return "";
  };

  const enableProductInstallment = (item) => {
    const currentPrice = formOnlineData?.formPricing?.prices?.find(
      (price) => price?._id === item?.priceId,
    );
    return currentPrice || {};
  };

  const shouldShowConvenienceFeeToggle =
    currentPaymentMethod?.coverConvenienceFee;
  const isConvenienceFeeOptional =
    currentPaymentMethod?.convenienceFeeInfo?.optional === true;

  return (
    <>
      <Paper
        sx={{
          minHeight: "278px",
          borderRadius: "10px",
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        }}
      >
        <Wrapper>
          <SummaryTitle>
            <span className="title_address_details">Summary</span>
          </SummaryTitle>
          <DataFoundWrapper>
            <PayDetails>
              {formOnlineData?.formPricing?.prices?.map((item, index) => {
                return (
                  <SummaryItem>
                    <div>
                      <li key={index}>
                        {item?.title}{" "}
                        {item?.isRecurring && "(Recurring Monthly)"}
                        <span>
                          {numberFormat({
                            number: +item.amount,
                            decimal: 2,
                            style: "currency",
                          })}
                        </span>
                      </li>
                      <p>{item?.note}</p>
                    </div>
                    {isInstallmentEnabled &&
                      item?.isInstallmentTransaction &&
                      !item?.isRecurring && (
                        <PaymentInstallment
                          onAllowInstallmentChange={(e) => {
                            const { checked } = e.target;
                            const updatedFormPricing = formOnlineData?.formPricing?.prices?.map(
                              (val) => {
                                if (val?._id === item?._id) {
                                  return {
                                    ...val,
                                    installmentStatus: checked,
                                    installment: null,
                                  };
                                }
                                return val;
                              },
                            );
                            const updatedFormDetails = {
                              ...formOnlineData,
                              formPricing: {
                                ...formOnlineData?.formPricing,
                                prices: updatedFormPricing,
                              },
                            };
                            dispatch(
                              formSlice.actions.setFormOnlineData(
                                updatedFormDetails,
                              ),
                            );
                            setActivePaymentAfter();
                          }}
                          installmentValue={item?.installmentStatus}
                          onSelectInstallment={(value) => {
                            const updatedFormPricing = formOnlineData?.formPricing?.prices?.map(
                              (val) => {
                                if (val?._id === item?._id) {
                                  return {
                                    ...val,
                                    installment: value,
                                  };
                                }
                                return val;
                              },
                            );
                            const updatedFormDetails = {
                              ...formOnlineData,
                              formPricing: {
                                ...formOnlineData?.formPricing,
                                prices: updatedFormPricing,
                              },
                            };
                            dispatch(
                              formSlice.actions.setFormOnlineData(
                                updatedFormDetails,
                              ),
                            );
                          }}
                          selectedInstallment={item?.installment}
                          installmentAmount={calculateInstallmentAmount(item)}
                          maxInstallment={
                            item?.installmentDetailsTransaction
                              ?.numberOfInstallment
                          }
                        />
                      )}
                  </SummaryItem>
                );
              })}
              {newProducts.map((product, index) => (
                <>
                  {product?.total > 0 && product?.amount > 0 && (
                    <SummaryItem>
                      <SummaryItemCharge>
                        <SummaryItemInfo>
                          <SummaryItemName>
                            {product?.total} {product?.title}
                          </SummaryItemName>
                        </SummaryItemInfo>
                        {`${numberFormat({
                          number: product?.amount,
                          decimal: 2,
                          style: "currency",
                        })}`}
                      </SummaryItemCharge>
                      {isInstallmentEnabled &&
                        enableProductInstallment(product)
                          ?.isInstallmentTransaction && (
                          <PaymentInstallment
                            onAllowInstallmentChange={(e) => {
                              const { checked } = e.target;
                              const updatedNewProducts = newProducts?.map(
                                (val) => {
                                  if (val?.title === product?.title) {
                                    return {
                                      ...val,
                                      installmentStatus: checked,
                                      ...(!checked && {
                                        installment: null,
                                      }),
                                    };
                                  }
                                  return val;
                                },
                              );
                              setProducts(updatedNewProducts);
                              setActivePaymentAfter();
                            }}
                            installmentValue={
                              product?.installmentStatus || false
                            }
                            onSelectInstallment={(value) => {
                              const updatedNewProducts = newProducts?.map(
                                (val) => {
                                  if (val?.title === product?.title) {
                                    return {
                                      ...val,
                                      installment: value,
                                    };
                                  }
                                  return val;
                                },
                              );
                              setProducts(updatedNewProducts);
                            }}
                            selectedInstallment={product?.installment}
                            installmentAmount={calculateInstallmentAmount(
                              product,
                              "product",
                            )}
                            maxInstallment={
                              enableProductInstallment(product)
                                ?.installmentDetailsTransaction
                                ?.numberOfInstallment || 24
                            }
                          />
                        )}
                    </SummaryItem>
                  )}
                </>
              ))}
            </PayDetails>
            {totalPay?.totalcountTickets > "0.00" && totalDiscount > 0 && (
              <PayDetails>
                <li>
                  Total Discount
                  <span>
                    {numberFormat({
                      number: +totalDiscount,
                      decimal: 2,
                      style: "currency",
                    })}
                  </span>
                </li>
              </PayDetails>
            )}
            {shouldShowConvenienceFeeToggle && (
              <SummaryItem>
                {/* <SummaryItemCharge>
                  <div>
                    <span style={{ color: "#002e5c", fontSize: "14px" }}>
                      Convenience Fee
                    </span>
                  </div>
                  <PaymentAmount>
                    {numberFormat({
                      number: calculateAmount?.convenienceFee,
                      decimal: 2,
                      style: "currency",
                    })}
                  </PaymentAmount>
                </SummaryItemCharge> */}
                {/* {isConvenienceFeeOptional && (
                  <div
                    className={`wrapper check-box__wrapper`}
                    style={{
                      display: "flex",
                      marginBottom: "10px",
                      marginTop: "10px",
                      color: "#002e5c",
                    }}
                  >
                    <label className="check-box-container">
                      <input
                        type="checkbox"
                        style={{ marginRight: 8 }}
                        checked={convenienceFeeByPayment[activePayment]}
                        onChange={(e) => {
                          setConvenienceFeeByPayment((prev) => ({
                            ...prev,
                            [activePayment]: e.target.checked,
                          }));
                        }}

                        // disabled={disabled}
                        // {...rest}
                      />
                      <span className={"checkbox-checkmark"}></span>
                    </label>
                    <span className="text">
                      {currentPaymentMethod?.convenienceFeeInfo?.message}
                    </span>
                  </div>
                )} */}
                {convenienceFeeByPayment[activePayment] && (
                  <SummaryItemCharge>
                    <div>
                      <span style={{ color: FontColors.Blue002E5C, fontSize: Fonts.GeneralAmountFont.fontSize }}>
                        Convenience Fee
                      </span>
                    </div>
                    <PaymentAmount>
                      {numberFormat({
                        number: calculateAmount?.convenienceFee,
                        decimal: 2,
                        style: "currency",
                      })}
                    </PaymentAmount>
                  </SummaryItemCharge>
                )}
                          {isConvenienceFeeOptional && (
                    <div
                      className={`wrapper check-box__wrapper`}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        paddingTop:"10px",
                        color: FontColors.Slate6B7280,
                        borderTop: "1px dashed rgba(0, 46, 92, 0.10)"

                      }}
                    >
                      <label className="check-box-container" style={{position:"absolute"}}>
                        <input
                          type="checkbox"
                          style={{ marginRight: 8 }}
                          checked={convenienceFeeByPayment[activePayment]}
                          onChange={(e) => {
                            setConvenienceFeeByPayment((prev) => ({
                              ...prev,
                              [activePayment]: e.target.checked,
                            }));
                          }}
                        />
                        <span className={"checkbox-checkmark"}></span>
                      </label>
                      <span className="text">
                        {currentPaymentMethod?.convenienceFeeInfo?.message}
                      </span>
                    </div>
                  )}
              </SummaryItem>
            )}
            <TotalPayment>
              <p>Payment Total</p>
              <span>
                {numberFormat({
                  number: calculateAmount?.totalWithConvenienceFee ?? 0,
                  decimal: 2,
                  style: "currency",
                })}
              </span>
            </TotalPayment>
            <TotalDueAmount>
              <p>Due Now</p>
              <span>
                {numberFormat({
                  number: calculateAmount?.dueWithConvenienceFee ?? 0,
                  decimal: 2,
                  style: "currency",
                })}
              </span>
            </TotalDueAmount>
          </DataFoundWrapper>
        </Wrapper>
      </Paper>
    </>
  );
};
